export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Oferta básica do Workspace com recursos inteligentes para funcionários modernos, que usam SaaS, aplicativos da web e serviços de compartilhamento de arquivos.</p><p>Inclui logon único com suporte para autenticação multifatorial em todos os aplicativos; inteligência de espaço de trabalho com microaplicativos, feeds personalizados e assistência virtual; além do serviço Citrix Content Collaboration Standard com armazenamento ilimitado de arquivos.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>A solução completa para funcionários que precisam de um espaço de trabalho digital completo, com segurança granular, mas que não demandam aplicativos e desktops virtuais.</p><p>Inclui a funcionalidade do Workspace Standard, além de controles avançados de segurança para SaaS e web, gerenciamento de endpoint unificado e o Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Solução abrangente de espaço de trabalho que inclui opções de implantação híbrida para o Citrix Virtual Apps and Desktops.</p><p>Inclui a funcionalidade Workspace Premium, além de uma opção de gerenciamento de nuvem para o Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>O Citrix Workspace Essentials ajuda pequenas e médias empresas a protegerem seus dados, simplificando e protegendo o processo de login em SaaS e aplicativos da web.</p><p>Inclui logon único em SaaS e aplicativos da Web com autenticação multifatorial para proteger ainda mais o processo de login, ajudando a reduzir as chances de comprometimento da conta em 99,9%.</p>"
            },
            terms: "*Por usuário, por mês",
            btn1: "Exibir a matriz de recursos"
        },
        features: {
            disclaimer1: "*Preço de tabela em dólares sugerido pelo fabricante, por mês, por 500 usuários, para uma assinatura de 3 anos. O preço real pode variar.<br /> As opções de licenciamento do Citrix Workspace começam com 25 usuários.",
            disclaimer2: "**O serviço Workspace Premium não inclui o Workspace Analytics para implantações no local do Citrix Virtual Apps and Desktops."
        },
        calculator: {
            edition: "Selecione a edição",
            title: "Calcule o preço",
            users: "Selecione os usuários",
            estCost: "Custo mensal estimado",
            btn1: "Fale com um especialista",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "As opções de licenciamento são a partir de 25 usuários. Tente outra vez.",
            lowUserMsg: "Tem menos que 500 usuários? Podemos ajudar com as necessidades de empresas pequenas ou médias.",
            volumeDiscount: "Mais de 2.500 usuários? Aproveite preços com desconto para grandes volumes.",
            contract1: "Contrato de 1 ano",
            contract3: "Contrato de 3 anos",
            contract3savings: "20% de desconto",
            term: "Por usuário, por mês",
            disclaimer: "*Esta calculadora fornece preços estimados e deve ser usada apenas para fins de orçamento. Os preços reais podem ser diferentes. Entre em contato com sua equipe ou parceiro da Citrix para obter os descontos válidos."
        },
        stats: {
            title: "Seus benefícios",
            stat1: {
                title: "Melhore a experiência dos funcionários",
                desc: "<b>4 de cada 5</b> líderes de TI acreditam que a experiência dos funcionários é fundamental para sua transformação digital."
            },
            stat2: {
                title: "Dê opções aos funcionários",
                desc: "<b>Setenta e oito por cento</b> dos líderes empresariais concordam que permitir aos funcionários escolher seus aplicativos e dispositivos preferidos ajuda a melhorar a experiência deles."
            },
            stat3: {
                title: "Simplifique o acesso",
                desc: "<b>Quarenta e sete por cento</b> dos líderes empresariais dizem que a maior contribuição para o envolvimento dos funcionários é a facilidade de acesso às informações necessárias para a execução do trabalho."
            },
            btn1: "Fale com um especialista",
            disclaimer: "Fonte: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}